import {
  defaultTab,
  filtersPerFacetValue,
  mlParametersProps
} from '../coveo/controllers/controller';
import { ExtendedWindowType } from './global-types';

type ResponseBodyFacetCurrentValue = {
  value: string;
  state: string;
};

type ResponseBodyFacet = {
  field: string;
  currentValues: ResponseBodyFacetCurrentValue[];
};

export const getFacetKeyFromHash = (targetKey: string) => {
  const hash = window.location.hash.slice(1); // Remove '#'
  const params = new URLSearchParams(hash);

  for (const [key, value] of params.entries()) {
    if (key === `f-${targetKey}`) {
      return { key, value };
    }
  }

  return null;
};

export const clearAllFacetsContext = () => {
  if (filtersPerFacetValue && filtersPerFacetValue?.length > 0) {
    filtersPerFacetValue.forEach(facet => {
      const { tab } = facet;

      if (tab) {
        defaultTab?.select();
      }
    });
  }
};

export const makePreprocessRequest = (
  body: string,
  facetField: string,
  facetValue: string,
  context?: Record<string, string>,
  mlParameters?: mlParametersProps
) => {
  const newBody = JSON.parse(body.toString());

  if (newBody.facets) {
    const contentType = newBody.facets.find(
      (facet: ResponseBodyFacet) => facet.field === facetField
    );

    if (contentType && contentType.currentValues.length > 0) {
      const selectedValues = contentType.currentValues.filter(
        (value: ResponseBodyFacetCurrentValue) => value.state === 'selected'
      );

      if (selectedValues && selectedValues.length === 1) {
        const isSelected = selectedValues.find(
          (value: ResponseBodyFacetCurrentValue) => value.value === facetValue
        );

        if (isSelected) {
          if (mlParameters) {
            newBody.mlParameters = mlParameters;
          }

          if (context) {
            if (newBody.context) {
              newBody.context = {
                ...newBody.context,
                ...context
              };
            } else {
              newBody.context = context;
            }
          }
        }
      }
    }
  }

  return JSON.stringify(newBody);
};

export const addFiltersPerFacetValue = (
  facetField: string,
  facetValue: string,
  context?: Record<string, string>,
  mlParameters?: mlParametersProps
) => {
  if (context || mlParameters) {
    const global = window as ExtendedWindowType;

    global.preProcessRequest = (body: string) => {
      return makePreprocessRequest(
        body,
        facetField,
        facetValue,
        context,
        mlParameters
      );
    };
  }
};
